import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getVmsSettings } from '../../../redux/actions/SocietyPortal/VmsAction/VmsAction';
import usePermissions from '../../../hook/usePermissions';
import { selectedSocietyStorer } from '../../../utils/webStorer';

// allow_resident_pre_approval and allow_resident_gate_pass are stored but never
// read by the backend — RBAC still lets a RESIDENT call the create endpoints
// regardless. So the flags are a UI policy: they hide the button for residents,
// and change nothing for staff roles.
//
// Returns `true` when the current user may create the thing, which is the
// answer both screens actually want.
export const useResidentPolicy = (settingKey) => {
    const dispatch = useDispatch();
    const societyId = selectedSocietyStorer.getSocietyId();
    const { role } = usePermissions();
    const settings = useSelector(state => state.VmsReducer?.settings?.data);

    useEffect(() => {
        if (societyId && !settings) dispatch(getVmsSettings({ societyId }));
    }, [dispatch, societyId, settings]);

    const isResident = role?.role_code === 'RESIDENT';
    if (!isResident) return true;

    const raw = settings?.[settingKey];
    // Until the settings land, assume allowed rather than flashing the button
    // away and back.
    if (raw === undefined || raw === null) return true;
    return raw === true || raw === 1;
};

export default useResidentPolicy;
